import {
  Component,
  Inject,
  Input,
  OnInit,
  EventEmitter,
  Output,
} from '@angular/core';
import { LoadConfigService } from '../../services/load-config.service';
import { StudyNavigationService } from '../../services/study-navigation.service';
import { InstructionModificationService } from '../../services/instruction-modification.service';
import { environment } from '../../../environments/environment';
import { PersistanceService } from '../../services/persistance.service';
import { StateService } from '../../services/state.service';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { UtilsService } from '../../services/utils.service';
import { BgColor } from '../../shared/types';
import { InstructionService } from '../../services/instruction.service';
import { ConfigApiService } from 'src/app/services/config-api.service';

@Component({
  selector: 'app-instruction-container-bg-mono',
  templateUrl: './instruction-container-bg-mono.component.html',
  styleUrls: ['./instruction-container-bg-mono.component.scss'],
})
export class InstructionContainerBgMonoComponent implements OnInit {
  @Input('instruction') instruction: string = 'practice-baseline';
  @Input('route') route: string = 'dns';
  @Input('label') label: string;
  @Input('showConsent') showConsent: boolean = false;
  @Input('section') section: string;
  @Input('showContinue') showContinue: boolean = true;
  @Input('isPracticeIntro') isPracticeIntro: boolean = false;
  @Input('isFinalPage') isFinalPage: boolean = false;
  @Input('bgColor') bgColor: string = 'mono';
  @Input('type') type: string;
  @Input('mode') mode: string;
  @Output('onClick') onClick = new EventEmitter();

  isValidBgColor: boolean = true;

  illustration;
  content;
  instructions;

  body: string;
  title: string;

  outroLabels: {
    before_link: string;
    in_link: string;
    after_link: string;
  };

  constructor(
    private navigation: StudyNavigationService,
    private loadConfigService: LoadConfigService,
    private modifyInstruction: InstructionModificationService,
    private persistanceService: PersistanceService,
    private stateService: StateService,
    private http: HttpClient,
    private utils: UtilsService,
    private instructionService: InstructionService,
    private configService: ConfigApiService,
    @Inject('BASE_URL') private baseUrl: string
  ) {}

  ngOnInit(): void {
    if (!this.label) {
      this.label = this.instructionService.getTranslationsForTerm(
        'INSTRUCTION_CONTINUE_BUTTON'
      );
    }

    this.outroLabels =
      this.instructionService.getTranslationsForTerm('OUTRO_FINISH_STUDY');

    this.instructions =
      this.instructionService.getInstructions('EN')[
        (console.log(this.instruction), this.instruction)
      ];

    if (!this.showConsent) {
      console.log(this.instruction['title']);
      this.title = this.instructions['title'];
      this.replacePlaceholders();
    }

    // const keys = this.getKeys();

    this.illustration = `${this.baseUrl}assets/images/keyboard/${this.instructions['illustration']}`;

    if (!this.utils.enumHasValue(BgColor, this.bgColor)) {
      this.isValidBgColor = false;
    }
  }

  get BgColor() {
    return BgColor;
  }

  navigateToNext() {
    if (this.isPracticeIntro) {
      this.onClick.emit();
      this.navigation.renderNext();
    }
  }

  replacePlaceholders() {
    this.body = this.modifyInstruction.replacePlaceholders(
      this.instructions['body'],
      this.instruction,
      this.section
    );
  }

  handleStudyFinish(e) {
    e.preventDefault();

    if (!this.isFinalPage) return;

    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
      };

      const urlForBackendCall = `${environment.backendURL}${environment.endpointToAgency}`;
      const request = this.http
        .get<{ url: string }>(urlForBackendCall, httpOptions)
        .pipe(
          retry(5),
          catchError((error: HttpErrorResponse) => {
            return throwError(
              'An error occurred when trying to redirect to agency'
            );
          })
        );
        request.subscribe(
        (res) => {
          this.persistanceService.clearSessionStorage();

          const redirectUrl = res.url;
          window.location.replace(redirectUrl);
        },
        (error) => {
          throw new Error(error);
        }
      );
    } catch (error) {
      console.error(error);
    }
  }
}
